<mat-toolbar class="d-flex justify-content-end matero-toolbar" color="secondary">
  <!-- right -->
  <div class="d-flex align-items-center">
    @if (showSearch) {
      <app-top-search></app-top-search>
    }
    <app-branding class="m-r-24 m-l-24"></app-branding>
  </div>
</mat-toolbar>
